angular.module('tf.controllers')
    .controller("DummyFarmerController",['$scope','WebSocketService','HttpService',function($scope, WebSocketService, HttpService){


        $scope.wss = WebSocketService;

        //Test remote fid = 'V++eL2rX4bc='
        HttpService.post("authenticate", {email: "jazzmanj@yahoo.com", password:"duba", fid:"testfid", root:"testrootid", rootName: "Root Folder", name: "Dummy Farmer"}).then(function(res){
            var token = res.data.access_token;
            WebSocketService.createWS(token);
        });


        WebSocketService.on('getFolders', handleGetFolders);
        WebSocketService.on('getProject', handleGetProject);
        WebSocketService.on('render', handleRender);
        WebSocketService.on('ping', pong);


        function handleGetFolders(data){
            if(false && !data.args || data.args.length === 0){
                WebSocketService.send("getFolders", 1, data.cid, root);
            } else if (data.args[0] == 'YzpcX0RFVlxUZW1w'){
                WebSocketService.send("getFolders", 1, data.cid, temp);
            } else if (data.args[0] == 'YzpcX0RFVlxWRlNfQ29udGVudA=='){
                WebSocketService.send("getFolders", 1, data.cid, newFolder);
            } else if (data.args[0] == 'testrootid'){
                WebSocketService.send("getFolders", 1, data.cid, root2);
            }
            else if (data.args[0] == 'Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q='){
                WebSocketService.send("getFolders", 1, data.cid, folders2);
            }
            else if (data.args[0] == 'Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybQ=='){
                WebSocketService.send("getFolders", 1, data.cid, folders3);
            }
            else if (data.args[0] == '=='){
                WebSocketService.send("getFolders", 1, data.cid, project3);
            }
            //


        }

        function handleGetProject(data){
            WebSocketService.send("getProject", 1, data.cid, project3);
        }
        function pong(data){
            WebSocketService.send("pong", 1, data.cid, project1);
        }

        function handleRender(data){
            var i = 0;
            WebSocketService.send("progress", 1, data.cid, "Starting render");
            var interval = setInterval(function(){
                WebSocketService.send("progress", 2, data.cid, i);
                i = i + 10;
                if(i > 100){
                    clearInterval(interval);
                    WebSocketService.send("unsubscribe", 2, data.cid, null);
                }
            },100);
        }

        var project = {
            name: "Dummy Project",
            location : "Dummy location",
            templates: [{name: "dummy-template", displayName: "Dummy template"}]
        };

        var root2 = {"breadcrumbs":[{"name":"root","id":"Qzpccm9vdA=="}],"content":[{"id":"Qzpccm9vdFxGaXJzdF9Qcm9qZWN0","pid":"Qzpccm9vdA==","name":"First_Project","type":0,"lastModified":"Sunday, February 21, 2016"},{"id":"Qzpccm9vdFxTa2UgUmVwbGFjZW1lbnQgZm9sZGVy","pid":"Qzpccm9vdA==","name":"Ske Replacement folder","type":0,"lastModified":"Tuesday, June 21, 2016"},{"id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q=","pid":"Qzpccm9vdA==","name":"Template Farm Project","type":0,"lastModified":"Thursday, May 5, 2016"},{"id":"Qzpccm9vdFxUZW1wbGF0ZV9GYXJtX2ZvbGRlcg==","pid":"Qzpccm9vdA==","name":"Template_Farm_folder","type":0,"lastModified":"Thursday, March 10, 2016"},{"id":"Qzpccm9vdFxWaWRlb0NvcGlsb3Q=","pid":"Qzpccm9vdA==","name":"VideoCopilot","type":0,"lastModified":"Tuesday, June 21, 2016"}]};
        var folders2 = {"breadcrumbs":[{"name":"root","id":"Qzpccm9vdA=="},{"name":"Template Farm Project","id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q="}],"content":[{"id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybQ==","pid":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q=","name":"Template Farm","type":0,"lastModified":"Thursday, May 5, 2016"}]};
        var folders3 = {"parent":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q=","breadcrumbs":[{"name":"root","id":"Qzpccm9vdA=="},{"name":"Template Farm Project","id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q="},{"name":"Template Farm","id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybQ=="}],"content":[{"id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMS50ZnA=","name":"Template Farm 101","sourceType":0,"type":1,"lastModified":"Thursday, May 5, 2016"}]};
        var project3 = {"name":"Template Farm 101","location":"/c/root/Template%20Farm%20Project/Template%20Farm/Template%20Farm%20101.aep","templates":[{"name":"01 Text","comp":"#01 Text#preview(75)","width":"1280","height":"720","duration":"150","preview":"75","controls":[{"name":"Sigis Layer","layerType":"text","comp":"#01 Text#preview(75)","layer":"#Sigis Layer","value":"Main Title","left":243.626831054688,"top":552.885192871094,"width":179.583953857422,"height":33.5690002441406,"ui":{"type":"text"}},{"name":"Sub Title","layerType":"text","comp":"#01 Text#preview(75)","layer":"#Sub Title","value":"Sub Title","left":244.299133300781,"top":607.269653320313,"width":116.286163330078,"height":24.5626831054688,"ui":{"type":"text"}}],"thumbnail":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMV8wMSBUZXh0MDAwNzUuanBn"},{"name":"02 Images","comp":"#02 Images#preview(75)","width":"1280","height":"720","duration":"150","preview":"75","controls":[{"name":"Main Title","layerType":"text","comp":"#02 Images#preview(75)","layer":"#Main Title","value":"Main Title","left":243.626831054688,"top":552.885192871094,"width":179.583953857422,"height":33.5690002441406,"ui":{"type":"text"}},{"name":"Sub Title","layerType":"text","comp":"#02 Images#preview(75)","layer":"#Sub Title","value":"Sub Title","left":244.299133300781,"top":607.269653320313,"width":116.286163330078,"height":24.5626831054688,"ui":{"type":"text"}},{"name":"Logo","layerType":"comp","comp":"#02 Images#preview(75)","layer":"#Logo","value":"","left":106,"top":548,"width":100,"height":100,"ui":{"type":"browse"}}],"thumbnail":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMV8wMiBJbWFnZXMwMDA3NS5qcGc="},{"name":"03 Nesting","comp":"#03 Nesting#preview(75)","width":"1280","height":"720","duration":"150","preview":"75","controls":[{"name":"Main Title","layerType":"text","comp":"#03 Nesting#preview(75)","layer":"#Main Title","value":"Main Title","left":243.626831054688,"top":552.885192871094,"width":179.583953857422,"height":33.5690002441406,"ui":{"type":"text"}},{"name":"Sub Title","layerType":"text","comp":"#03 Nesting#preview(75)","layer":"#Sub Title","value":"Sub Title","left":244.299133300781,"top":607.269653320313,"width":116.286163330078,"height":24.5626831054688,"ui":{"type":"text"}},{"name":"Logo","layerType":"comp","comp":"Logo","layer":"#Logo","value":"","ui":{"type":"browse"},"left":106,"top":548,"width":100,"height":100}],"thumbnail":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMV8wMyBOZXN0aW5nMDAwNzUuanBn"},{"name":"04 Controls","comp":"#04 Controls#preview(75)","width":"1280","height":"720","duration":"150","preview":"75","controls":[{"name":"Main Title","layerType":"text","comp":"#04 Controls#preview(75)","layer":"#Main Title","value":"Main Title","left":243.626831054688,"top":552.885192871094,"width":179.583953857422,"height":33.5690002441406,"ui":{"type":"text"}},{"name":"Title Color","layerType":"control","comp":"#04 Controls#preview(75)","layer":"#Main Title","effect":"#Title Color","value":"#ef4136","ui":{"type":"color"}},{"name":"Sub Title","layerType":"text","comp":"#04 Controls#preview(75)","layer":"#Sub Title","value":"Sub Title","left":244.299133300781,"top":607.269653320313,"width":116.286163330078,"height":24.5626831054688,"ui":{"type":"text"}},{"name":"Sub Title Color","layerType":"control","comp":"#04 Controls#preview(75)","layer":"#Sub Title","effect":"#Sub Title Color","value":"#ece7ca","ui":{"type":"color"}},{"name":"Logo","layerType":"comp","comp":"Logo","layer":"#Logo","value":"","ui":{"type":"browse"},"left":106,"top":548,"width":100,"height":100}],"thumbnail":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMV8wNCBDb250cm9sczAwMDc1LmpwZw=="},{"name":"05 UI","comp":"#05 UI#preview(75)","width":"1280","height":"720","duration":"150","preview":"75","controls":[{"name":"Main Title","layerType":"text","comp":"#05 UI#preview(75)","layer":"#Main Title#ui(options,Title 1,Title 2, Title 3)","value":"Main Title","left":243.626831054688,"top":552.885192871094,"width":179.583953857422,"height":33.5690002441406,"ui":{"type":"options","args":["Title 1","Title 2"," Title 3"]}},{"name":"Title Color","layerType":"control","comp":"#05 UI#preview(75)","layer":"#Main Title#ui(options,Title 1,Title 2, Title 3)","effect":"#Title Color","value":"#ef4136","ui":{"type":"color"}},{"name":"Sub Title","layerType":"text","comp":"#05 UI#preview(75)","layer":"#Sub Title#ui(slider,0,100,1)","value":"Sub Title","left":244.299133300781,"top":607.269653320313,"width":116.286163330078,"height":24.5626831054688,"ui":{"type":"slider","args":["0","100","1"]}},{"name":"Logo","layerType":"comp","comp":"Logo","layer":"#Logo","value":"","ui":{"type":"browse"},"left":106,"top":548,"width":100,"height":100}],"thumbnail":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMV8wNSBVSTAwMDc1LmpwZw=="}],"breadcrumbs":[{"name":"root","id":"Qzpccm9vdA=="},{"name":"Template Farm Project","id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3Q="},{"name":"Template Farm","id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybQ=="}],"id":"Qzpccm9vdFxUZW1wbGF0ZSBGYXJtIFByb2plY3RcVGVtcGxhdGUgRmFybVxUZW1wbGF0ZSBGYXJtIDEwMS50ZnA=","settings":{"name":"New Settings File","templatesRename":true,"filterTemplates":true,"useSaveTo":true,"saveTo":"C:\\Output","copy":[],"scripts":[],"pluginsSettings":[]}};

        var root = {content: [{"id":"YzpcX0RFVlxUZW1w","pid":"YzpcX0RFVg==","name":"Temp","type":0,"lastModified":"Thursday, January 07, 2016","breadcrumbs":["{\"name\":\"_DEV\",\"id\":\"YzpcX0RFVg==\"}"]},{"id":"YzpcX0RFVlxWRlNfQ29udGVudA==","pid":"YzpcX0RFVg==","name":"VFS_Content","type":0,"lastModified":"Yesterday at 6:40 PM","thumbnail":"YzpcX0RFVlxWRlNfQ29udGVudFx0ZXN0X1RIVU1CLmpwZw==","breadcrumbs":["{\"name\":\"_DEV\",\"id\":\"YzpcX0RFVg==\"}"]}]};
        var temp = {content: [{"id":"YzpcX0RFVlxUZW1wXE5ldyBmb2xkZXI=","pid":"YzpcX0RFVlxUZW1w","name":"New folder","type":0,"lastModified":"Thursday, January 07, 2016","breadcrumbs":["{\"name\":\"Temp\",\"id\":\"YzpcX0RFVlxUZW1w\"}","{\"name\":\"_DEV\",\"id\":\"YzpcX0RFVg==\"}"]},{"id":"YzpcX0RFVlxUZW1wXHByb2oudmZz","name":"proj","type":1,"lastModified":"Thursday, January 07, 2016","breadcrumbs":["{\"name\":\"Temp\",\"id\":\"YzpcX0RFVlxUZW1w\"}","{\"name\":\"_DEV\",\"id\":\"YzpcX0RFVg==\"}"]}]};
        var newFolder = {content: [{"id":"YzpcX0RFVlxUZW1wXE5ldyBmb2xkZXJccHJvai52ZnM=","name":"proj","type":1,"lastModified":"Thursday, January 07, 2016","breadcrumbs":["{\"name\":\"New folder\",\"id\":\"YzpcX0RFVlxUZW1wXE5ldyBmb2xkZXI=\"}","{\"name\":\"Temp\",\"id\":\"YzpcX0RFVlxUZW1w\"}","{\"name\":\"_DEV\",\"id\":\"YzpcX0RFVg==\"}"]}]};

        var project2 = {
            "name": "Template Farm 101",
            "location": "/c/_DEV/Template%20Farm/Template%20Farm%20101.aep",
            "templates": [
                {
                    "name": "01 Text",
                    "comp": "#01 Text#preview(75)",
                    "width": "1280",
                    "height": "720",
                    "duration": "150",
                    "preview": "75",
                    "controls": [
                        {
                            "name": "Joels Layer",
                            "layerType": "text",
                            "comp": "#01 Text#preview(75)",
                            "layer": "#Joels Layer",
                            "value": "Main Title",
                            "left": 245.1533203125,
                            "top": 553.22802734375,
                            "width": 176.19189453125,
                            "height": 33.3125,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Sub Title",
                            "layerType": "text",
                            "comp": "#01 Text#preview(75)",
                            "layer": "#Sub Title",
                            "value": "Sub Title",
                            "left": 245.1533203125,
                            "top": 607.5205078125,
                            "width": 114.0234375,
                            "height": 24.375,
                            "ui": {
                                "type": "text"
                            }
                        }
                    ]
                },
                {
                    "name": "02 Images",
                    "comp": "#02 Images#preview(75)",
                    "width": "1280",
                    "height": "720",
                    "duration": "150",
                    "preview": "75",
                    "controls": [
                        {
                            "name": "Main Title",
                            "layerType": "text",
                            "comp": "#02 Images#preview(75)",
                            "layer": "#Main Title",
                            "value": "Main Title",
                            "left": 245.1533203125,
                            "top": 553.22802734375,
                            "width": 176.19189453125,
                            "height": 33.3125,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Sub Title",
                            "layerType": "text",
                            "comp": "#02 Images#preview(75)",
                            "layer": "#Sub Title",
                            "value": "Sub Title",
                            "left": 245.1533203125,
                            "top": 607.5205078125,
                            "width": 114.0234375,
                            "height": 24.375,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Logo",
                            "layerType": "comp",
                            "comp": "#02 Images#preview(75)",
                            "layer": "#Logo",
                            "value": "",
                            "left": 106,
                            "top": 548,
                            "width": 100,
                            "height": 100,
                            "ui": {
                                "type": "browse"
                            }
                        }
                    ]
                },
                {
                    "name": "03 Nesting",
                    "comp": "#03 Nesting#preview(75)",
                    "width": "1280",
                    "height": "720",
                    "duration": "150",
                    "preview": "75",
                    "controls": [
                        {
                            "name": "Main Title",
                            "layerType": "text",
                            "comp": "#03 Nesting#preview(75)",
                            "layer": "#Main Title",
                            "value": "Main Title",
                            "left": 245.1533203125,
                            "top": 553.22802734375,
                            "width": 176.19189453125,
                            "height": 33.3125,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Sub Title",
                            "layerType": "text",
                            "comp": "#03 Nesting#preview(75)",
                            "layer": "#Sub Title",
                            "value": "Sub Title",
                            "left": 245.1533203125,
                            "top": 607.5205078125,
                            "width": 114.0234375,
                            "height": 24.375,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Logo",
                            "layerType": "comp",
                            "comp": "Logo",
                            "layer": "#Logo",
                            "value": "",
                            "ui": {
                                "type": "browse"
                            },
                            "left": 106,
                            "top": 548,
                            "width": 100,
                            "height": 100
                        }
                    ]
                },
                {
                    "name": "04 Controls",
                    "comp": "#04 Controls#preview(75)",
                    "width": "1280",
                    "height": "720",
                    "duration": "150",
                    "preview": "75",
                    "controls": [
                        {
                            "name": "Main Title",
                            "layerType": "text",
                            "comp": "#04 Controls#preview(75)",
                            "layer": "#Main Title",
                            "value": "Main Title",
                            "left": 245.1533203125,
                            "top": 553.22802734375,
                            "width": 176.19189453125,
                            "height": 33.3125,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Title Color",
                            "layerType": "control",
                            "comp": "#04 Controls#preview(75)",
                            "layer": "#Main Title",
                            "effect": "#Title Color",
                            "value": "#ef4136",
                            "ui": {
                                "type": "color"
                            }
                        },
                        {
                            "name": "Sub Title",
                            "layerType": "text",
                            "comp": "#04 Controls#preview(75)",
                            "layer": "#Sub Title",
                            "value": "Sub Title",
                            "left": 245.1533203125,
                            "top": 607.5205078125,
                            "width": 114.0234375,
                            "height": 24.375,
                            "ui": {
                                "type": "text"
                            }
                        },
                        {
                            "name": "Sub Title Color",
                            "layerType": "control",
                            "comp": "#04 Controls#preview(75)",
                            "layer": "#Sub Title",
                            "effect": "#Sub Title Color",
                            "value": "#ece7ca",
                            "ui": {
                                "type": "color"
                            }
                        },
                        {
                            "name": "Logo",
                            "layerType": "comp",
                            "comp": "Logo",
                            "layer": "#Logo",
                            "value": "",
                            "ui": {
                                "type": "browse"
                            },
                            "left": 106,
                            "top": 548,
                            "width": 100,
                            "height": 100
                        }
                    ]
                },
                {
                    "name": "05 UI",
                    "comp": "#05 UI#preview(75)",
                    "width": "1280",
                    "height": "720",
                    "duration": "150",
                    "preview": "75",
                    "controls": [
                        {
                            "name": "Main Title",
                            "layerType": "text",
                            "comp": "#05 UI#preview(75)",
                            "layer": "#Main Title#ui(options,Title 1,Title 2, Title 3)",
                            "value": "Main Title",
                            "left": 245.1533203125,
                            "top": 553.22802734375,
                            "width": 176.19189453125,
                            "height": 33.3125,
                            "ui": {
                                "type": "options",
                                "args": [
                                    "Title 1",
                                    "Title 2",
                                    " Title 3"
                                ]
                            }
                        },
                        {
                            "name": "Title Color",
                            "layerType": "control",
                            "comp": "#05 UI#preview(75)",
                            "layer": "#Main Title#ui(options,Title 1,Title 2, Title 3)",
                            "effect": "#Title Color",
                            "value": "#ef4136",
                            "ui": {
                                "type": "color"
                            }
                        },
                        {
                            "name": "Sub Title",
                            "layerType": "text",
                            "comp": "#05 UI#preview(75)",
                            "layer": "#Sub Title#ui(slider,0,100,1)",
                            "value": "Sub Title",
                            "left": 245.1533203125,
                            "top": 607.5205078125,
                            "width": 114.0234375,
                            "height": 24.375,
                            "ui": {
                                "type": "slider",
                                "args": [
                                    "0",
                                    "100",
                                    "1"
                                ]
                            }
                        },
                        {
                            "name": "Logo",
                            "layerType": "comp",
                            "comp": "Logo",
                            "layer": "#Logo",
                            "value": "",
                            "ui": {
                                "type": "browse"
                            },
                            "left": 106,
                            "top": 548,
                            "width": 100,
                            "height": 100
                        }
                    ]
                }
            ]
        };

    }]);
